import { render, staticRenderFns } from "./2_howto.vue?vue&type=template&id=f254d752&scoped=true&"
import script from "./2_howto.vue?vue&type=script&lang=js&"
export * from "./2_howto.vue?vue&type=script&lang=js&"
import style0 from "./2_howto.vue?vue&type=style&index=0&id=f254d752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f254d752",
  null
  
)

export default component.exports